import useIntl from '../../../../hooks/useIntl';
import useNameSuffixesQuery from '../../../../hooks/data-fetching/useNameSuffixesQuery';
import messages from '../../messages';

export type UseAllNameSuffixesReturn = {
  nameSuffixes: Array<{ value: ?string, text: string }>,
  isLoading: boolean,
};

export default function useAllNameSuffixes(): UseAllNameSuffixesReturn {
  const intl = useIntl();
  const { nameSuffixOptions, isLoading } = useNameSuffixesQuery();

  const dataToReturn = !isLoading
    ? [
        // Add a default empty option
        { value: null, text: intl.formatMessage(messages.selectSuffix) },
        ...nameSuffixOptions,
      ]
    : null;

  return {
    nameSuffixes: dataToReturn,
    isLoading,
  };
}
